<template>
  <div v-loading="loading">
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <span class="card-icon">
            <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <router-link :to="{ name: 'subcontractor-detail', params: {id: answer_id} }" v-slot="{ href, navigate, isActive, isExactActive }">
            <a href="href" @click="navigate"><u>{{display_name}}</u></a>
          </router-link>
        </div>
      </div>
      <div class="card-body">
        <div class="text-center mb-4">
          <div v-if="business_from && business_to">
            <p class="mb-0">事業期間：</p>
            <p>{{`${business_from} ~ ${business_to}`}}</p>
          </div>
          <el-radio-group v-model="form.month" text-color="black" fill="#E4E6Ef">
            <el-radio-button label="04" :disabled="disabledDate(moment(`${year}-04`))" class="mr-2">4月</el-radio-button>
            <el-radio-button label="05" :disabled="disabledDate(moment(`${year}-05`))" class="mr-2">5月</el-radio-button>
            <el-radio-button label="06" :disabled="disabledDate(moment(`${year}-06`))" class="mr-2">6月</el-radio-button>
            <el-radio-button label="07" :disabled="disabledDate(moment(`${year}-07`))" class="mr-2">7月</el-radio-button>
            <el-radio-button label="08" :disabled="disabledDate(moment(`${year}-08`))" class="mr-2">8月</el-radio-button>
            <el-radio-button label="09" :disabled="disabledDate(moment(`${year}-09`))" class="mr-2">9月</el-radio-button>
            <el-radio-button label="10" :disabled="disabledDate(moment(`${year}-10`))" class="mr-2">10月</el-radio-button>
            <el-radio-button label="11" :disabled="disabledDate(moment(`${year}-11`))" class="mr-2">11月</el-radio-button>
            <el-radio-button label="12" :disabled="disabledDate(moment(`${year}-12`))" class="mr-2">12月</el-radio-button>
            <el-radio-button label="01" :disabled="disabledDate(moment(`${year}-01`))" class="mr-2">1月</el-radio-button>
            <el-radio-button label="02" :disabled="disabledDate(moment(`${year}-02`))" class="mr-2">2月</el-radio-button>
            <el-radio-button label="03" :disabled="disabledDate(moment(`${year}-03`))" class="mr-2">3月</el-radio-button>
          </el-radio-group>
        </div>
        <div class="d-flex justify-content-between">
          <a v-if="url_link" class="align-self-end" style="font-size: 1rem" :href="url_link" target="_blank">{{url_link}}</a>
          <div>
            <el-date-picker
                @change="changeYear"
              v-model="year"
              :picker-options="pickerOptions"
              style="width: 100px"
              :clearable="false"
              type="year"
              value-format="yyyy"
              placeholder="--"
              prefix-icon="el-icon-arrow-down"
              :editable="false"></el-date-picker>
            <span class="ml-2">年</span>
          </div>
        </div>
          <reject-comment class="mt-3" :formAnserDetail="formAnserDetail"></reject-comment>
        <el-table
          :data="tableData"
          border
          stripe
          header-cell-class-name="text-center"
          :header-cell-style="{ background: '#181c32', color: 'white' }"
        >
          <el-table-column fixed prop="title" label="項目" align="left" :width="tableData.length !== 0 ? '326' : ''"></el-table-column>
          <el-table-column prop="isHad" label="有無" width="100"></el-table-column>
          <el-table-column label="添付" >
            <template slot-scope="scope">
              <el-link type="primary" :href="download_url+scope.row.url" download>{{scope.row.link_name}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="備考" ></el-table-column>

        </el-table>

        <div class="text-center mt-5">
              <span>
                <button v-if="approval" @click="changeStatus(1)" class="btn btn-secondary mr-4">承認
                </button>
                <button v-if="denial" @click="changeStatus(2)" class="btn btn-secondary mr-4">否認
                </button>
              </span>
              <button v-if="sendBack" @click="changeStatus(3)" class="btn btn-secondary">差し戻し
              </button>
            </div>
      </div>
    </div>

    <el-dialog
      :lock-scroll="false"
      :visible.sync="dialog.dialog"
      width="50%"
      class="content_popup"
      :show-close="false"
      center>
        <div class="textwidget text-center">
            {{ dialog.headerText }}理由を入力してください
        </div>

        <el-input class="mt-10" type="textarea" :rows="3" placeholder="入力してください" v-model="dialog.reason"></el-input>

        <span slot="footer" class="dialog-footer">
          <el-button :disabled="dialog.reason.length == 0" class="btn_submit_dialog" @click="setStatus(dialog.status)">処理確定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import apiService from "@/core/services/api.service";
import { mapActions, mapGetters } from 'vuex';
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import { GET_DETAIL_ANSWER } from "@/core/services/store/formAnswer.module";
import { ENV } from "@/core/config/env";
import { SUCCESS_MESSAGE } from "@/core/config/constant";
import moment from 'moment';

export default {
  data() {
    return {
      loading: false,
      data: [],
      answer_id: null,
      display_name: '',
      form_answer_id: null,
        year: null,
      form: {
        month: null
      },
      url_link: '',
      approval:false,
      denial:false,
      sendBack:false,
      download_url: '',
      business_from: '',
      business_to: '',
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      moment: moment,
      dialog: {
        dialog: false,
        status: null,
        headerText: '',
        reason: ''
      }
    };
  },
  async created() {
    this.loading = true;

    this.answer_id = this.$route.params.answer_id
    await this.getDetailAnswer({ id: this.answer_id })
    this.display_name = this.detailAnswer.display_name

    this.download_url = ENV.DOWNLOAD_URL
    await this.GetAllUrlAdmin()
    this.url_link = ENV.APP_URL_DOMAIN + `${this.detailAnswer.tenant_code}/${this.detailAnswer.form1_url}/${this.detailAnswer.answer_id}/${this.form5Url}`

    if (this.BusinessTitle == null) {
      await this.setTitleBusiness()
    }

    if (!this.listExistForm5.length) {
      await this.getListExistForm5(this.answer_id)
      if (this.listExistForm5.first_date) {
        const date = moment(this.listExistForm5.first_date, 'YYYY-MM')
        this.year = date.format('YYYY')
          this.getDataFirst(this.year)
         //this.form.month = date.format("MM")
      } else {
        if (this.getBusiness) {
          const date = new Date(this.getBusiness.jigyo_kikan_from)
          this.year = date.getFullYear().toString()
          this.form.month = moment(date).format("MM")
        } else {
          const date = moment()
          this.year = date.format('YYYY')
          this.form.month = date.format("MM")
        }
      }
    } else {
        const date = moment(this.listExistForm5.first_date, 'YYYY-MM')
        this.year = date.format('YYYY')
        this.getDataFirst(this.year)
        // this.form.month = date.format("MM")
    }

    if (this.getBusiness) {
      this.business_from = moment(this.getBusiness.jigyo_kikan_from).format('YYYY/MM/DD')
      this.business_to = moment(this.getBusiness.jigyo_kikan_to).format('YYYY/MM/DD')
    }
    this.loading = false;
  },
  computed: {
    ...mapGetters(["BusinessTitle", 'getBusiness', "form5", "answerChildStatus", "answerChildErrors", "detailAnswer", "form5AnswerId", "form5Url", "form5Link", "listExistForm5","formAnserDetail"]),
    existArray() {
      let result = []
      if (this.listExistForm5.list_date) {
        for (const [year, arrayMonth] of Object.entries(this.listExistForm5.list_date)) {
          arrayMonth.forEach(month => {
            const date = moment(`${year}-${month}`, 'YYYY-MM')

            result.push(date)
          })
        }
      }
      return result
    },
    tableData() {
      let array = []
      let isRemark = true

      let obj = {}

      this.data.forEach(data => {
        if (data.item_name != "form5_date") {
          isRemark = !isRemark
          if (!isRemark) {
            obj = {
              label: data.item_name,
              title: data.label_name,
              link: data.value
            }
          } else {
            obj['remarks'] = data.value == 'null' ? null : data.value
            array.push(obj)
          }
        }
      })

      if (this.form5Link) {
        this.form5Link.forEach(link => {
          array.map(array_item => {
            if (array_item.label == link.item_name) {
              array_item['url'] = link.answer_value
              array_item['link_name'] = link.answer_string
            }
          })
        })
      }

      array.map(array_item => {
        array_item['isHad'] = array_item.link ? '有' : '無'
      })

      return array
    }
  },
  watch: {
    "dialog.dialog"() {
      if (this.dialog.dialog == false) {
        this.dialog.reason = ''
      }
    },
    form: {
      handler: async function (oldValue,newValue) {
        if (this.year && this.form.month) {
          const date = `${this.year}-${this.form.month}`
          const payload = {
            answer_id: this.answer_id,
            date: date
          }
          this.loading = true
          await this.getListAnswerForm5(payload)

          if (this.answerChildStatus == 200) {
            this.data = this.form5
            this.form_answer_id = this.form5AnswerId
          }
          if (this.answerChildStatus == 422) {
            this.notifyError(this.answerChildErrors)
            this.data = this.form5
          }
          await this.checkApproval()
          this.loading = false
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([SET_TITLE_BUSINESS, GET_DETAIL_ANSWER, "getListAnswerForm5", "GetAllUrlAdmin", "getListExistForm5"]),
    async changeStatus(status){
      if (status == 2 || status == 3) {
        this.dialog.status = status
        this.dialog.headerText = status == 2 ? '否認' : '差し戻し'
        this.dialog.dialog = true
      }
      if (status == 1) {
        this.setStatus(1)
      }
    },
    async setStatus(status) {
      this.loading = true
      apiService.post(`form/approval-answer/${this.form_answer_id}/${status}`, {reject_reason: this.dialog.reason}).then(async (data) => {
        if (data && data.data && data.data.success) {
          await this.checkApproval()
            if (this.year && this.form.month) {
                const date = `${this.year}-${this.form.month}`
                const payload = {
                    answer_id: this.answer_id,
                    date: date
                }
                await this.getListAnswerForm5(payload)
            }
          this.notifySuccess(SUCCESS_MESSAGE)
          this.dialog.dialog = false
        } else {
          if (data.data.code == 403 || data.data.code == 422) {
            this.notifyError(data.data.data)
          } else {
            this.notifyError('error server')
          }
        }
      })
        .catch(e => {
          this.notifyError(e)
          this.loading = false

        })

      this.loading = false
    },
    async checkApproval() {
      this.approval = false
      this.denial = false
      this.sendBack = false
      if (this.form_answer_id) {
        await this.getDetailAnswer({ id: this.form_answer_id })
        if (this.detailAnswer.is_view_list_approval) {
          if (this.detailAnswer.is_approval) {
            if (this.detailAnswer.status == 0) {
              this.sendBack = true
              this.denial = true
              this.approval = true
            }
            if (this.detailAnswer.status == 1) {
              if (!this.detailAnswer.status != 2 || !this.detailAnswer.status != 3) {
                this.sendBack = true
              }
            }
          } else {
            if ([0, 1].includes(this.detailAnswer.status)) {
              this.sendBack = true
            }
          }
        }
      }
    },
    disabledDate(date) {
      if (this.getBusiness) {
        let result = false
        if (moment(date).isBefore(this.getBusiness.jigyo_kikan_from, 'month') || moment(date).isAfter(this.getBusiness.jigyo_kikan_to, 'month')) {
          result = true
        } else {
          if (!this.existArray.length) {
            result = true
          } else {
            const hasExistDate = this.existArray.filter(existDate => existDate.isSame(moment(date)))
            if (!hasExistDate.length) {
              result = true
            }
          }
        }
        return result
      } else return true
    },
      changeYear(){
          this.form.month = null
          if (this.listExistForm5.list_date[this.year]) {
              this.getDataFirst(this.year)
          }
      },
      getDataFirst(year){
          const monthView=['04','05','06','07','08','09','10','11','12','01','02','03'];
          const listData =  this.listExistForm5.list_date[year];
          monthView.some((month) => {
              if (listData.includes(month)){
                  this.form.month = month
                  return true;
              }
              return false;

          });
      }
  }
}
</script>

<style>
.table-top,.table-top th,.table-top td {
  border: 1px solid #EBEDF3;
  border-collapse: collapse;
}

.el-radio-button__inner {
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: rgb(220, 223, 230);

}
</style>
